import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { NavigationComponent } from "./components/navigation/navigation.component";
import { MvTilesetsComponent } from "./components/mv-tilesets/mv-tilesets.component";
import { DashboardComponent } from "./components/dashboard/dashboard.component";
import { GameDetailComponent } from "./components/game-detail/game-detail.component";
import { TestComponent } from "./components/test/test.component";
import { AngularFireModule } from "@angular/fire";
import { AngularFirestoreModule } from "@angular/fire/firestore";
import { environment } from "../environments/environment";
import { ContactComponent } from "./components/contact/contact.component";
import { SoftwareComponent } from "./components/software/software.component";

@NgModule({
  declarations: [
    AppComponent,
    NavigationComponent,
    MvTilesetsComponent,
    DashboardComponent,
    GameDetailComponent,
    TestComponent,
    ContactComponent,
    SoftwareComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    AngularFirestoreModule,
    AngularFireModule.initializeApp(environment.firebase),
  ],
  providers: [],
  bootstrap: [AppComponent],
})
export class AppModule {}
